<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Notifications" pageTitle="Notifications" />
            <NotificationsContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import NotificationsContent from '../Notifications/NotificationsContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'NotificationsPage',
    components: {
        MainHeader,
        PageTitle,
        NotificationsContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>